import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Global } from "@emotion/react";
import globalCss from "./constants/global-styles";
import store from "./redux/store";
import { AppRoutes } from "./routes";
import { ErrorModalProvider } from "./components";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.min.css";
import { StrictMode } from "react";

export const App = () => (
    <StrictMode>
        <Global styles={globalCss} />
        <Provider store={store}>
            <ErrorModalProvider>
                <BrowserRouter>
                    <AppRoutes />
                </BrowserRouter>
            </ErrorModalProvider>
            <ToastContainer position="top-center" autoClose={2000} />
        </Provider>
    </StrictMode>
);
